import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { portalApi } from "@/lib/portalApi";

export default function PortalDashboardPage() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    portalApi
      .dashboard()
      .then(setStats)
      .catch((err) => setError(err.message));
  }, []);

  return (
    <>
      <h1>Dashboard</h1>
      <p className="muted">Mailing marketing overview</p>
      {error && <div className="portal-alert portal-alert--error">{error}</div>}
      {stats && (
        <div className="portal-grid">
          <div className="portal-stat">
            <strong>{stats.lists}</strong>
            Lists
          </div>
          <div className="portal-stat">
            <strong>{stats.subscribers}</strong>
            Active subscribers
          </div>
          <div className="portal-stat">
            <strong>{stats.templates}</strong>
            Templates
          </div>
          <div className="portal-stat">
            <strong>{stats.campaigns}</strong>
            Campaigns
          </div>
          <div className="portal-stat">
            <strong>{stats.smtp_configured ? "Ready" : "Needed"}</strong>
            SMTP
          </div>
        </div>
      )}
      <div className="portal-actions" style={{ marginTop: "1.5rem" }}>
        <Link className="btn" to="/portal/campaigns">
          New campaign
        </Link>
        <Link className="btn btn--ghost" to="/portal/lists">
          Manage lists
        </Link>
        {!stats?.smtp_configured && (
          <Link className="btn btn--ghost" to="/portal/settings/smtp">
            Configure SMTP
          </Link>
        )}
      </div>
    </>
  );
}
